export type CustomHeadersType = {
  [key in ProductFields]?: {
    key: string
    required: boolean
  }
}

export enum UploadBulkProductsType {
  SHOPIFY = "Shopify",
  CUSTOM = "Custom",
}

export enum ProductFields {
  PRODUCT_NAME = "productName",
  BRAND = "brand",
  SKU = "sku",
  SKU_NAME = "skuName",
  TYPE = "type",
  REGION = "region",
  FINISH = "finish",
  COVER = "cover",
  COLOR = "color",
  COVERAGE = "coverage",
  CATEGORY = "category",
}

export const customDefaultHeaders: CustomHeadersType = {
  [ProductFields.PRODUCT_NAME]: { key: "Name", required: true },
  [ProductFields.BRAND]: { key: "Brand", required: true },
  [ProductFields.COVER]: { key: "Image", required: true },
  [ProductFields.SKU]: { key: "Stock Keeping Unit", required: true },
  [ProductFields.CATEGORY]: { key: "Category", required: true },
  [ProductFields.SKU_NAME]: { key: "SKU name", required: true },
  [ProductFields.TYPE]: { key: "Type", required: true },
  [ProductFields.REGION]: { key: "Region", required: true },
  [ProductFields.FINISH]: { key: "Finish", required: true },
  [ProductFields.COVERAGE]: { key: "Coverage", required: true },
  [ProductFields.COLOR]: { key: "Color", required: true },
}
